// Duplicate-review modal — extracted from Vault.tsx. Lists keep/remove per group
// and asks for confirmation before deleting anything.

export interface DupGroup {
  keep: { id: string; title: string | null; sample: string };
  remove: { id: string; title: string | null; sample: string }[];
}

export function DedupModal({ groups, applying, onClose, onApply }: {
  groups: DupGroup[]; applying: boolean; onClose: () => void; onApply: (removeIds: string[]) => void;
}) {
  const removeCount = groups.reduce((s, g) => s + g.remove.length, 0);
  return (
    <div className="fixed inset-0 z-[115] bg-black/65 backdrop-blur-md grid place-items-center p-4" onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} className="w-[min(640px,94vw)] max-h-[85vh] overflow-y-auto bg-void border border-ink/15 rounded-2xl p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-serif text-xl text-ink">Duplicates — {removeCount} to remove</h3>
          <button onClick={onClose} className="w-8 h-8 rounded-full border border-ink/15 grid place-items-center text-ink/50 hover:text-ink">✕</button>
        </div>
        <p className="font-serif italic text-[13px] text-ink/55">For each group we keep the best one (reviewed → longest → oldest) and remove the rest.</p>
        <ul className="space-y-3">
          {groups.map((g, i) => (
            <li key={i} className="rounded-xl border border-ink/[0.08] p-3 space-y-1.5">
              <div className="text-[10px] text-emerald-300/80">keep</div>
              <div className="font-serif text-[13px] text-ink/80">{g.keep.title || g.keep.sample}</div>
              <div className="text-[10px] text-red-300/70 pt-1">remove {g.remove.length}</div>
              {g.remove.map((r) => <div key={r.id} className="font-serif text-[12px] text-ink/45 line-through">{r.title || r.sample}</div>)}
            </li>
          ))}
        </ul>
        <div className="flex items-center justify-end gap-2 pt-1 border-t border-ink/10">
          <button onClick={onClose} className="px-3 py-1.5 rounded-full border border-ink/20 text-[11.5px] text-ink/60 hover:text-ink">Cancel</button>
          <button onClick={() => onApply(groups.flatMap((g) => g.remove.map((r) => r.id)))} disabled={applying}
            className="px-4 py-1.5 rounded-full bg-red-400 text-void text-[11.5px] hover:bg-red-300 disabled:opacity-40">
            {applying ? '…' : `Remove ${removeCount} duplicate(s)`}
          </button>
        </div>
      </div>
    </div>
  );
}
